if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
var cio_config = require("cio-config");

var PackageGeneratorInspectorConfig = {};

PackageGeneratorInspectorConfig.getSelectbox = function(label, datamember, list, visibleDataMember, readOnly) {
    return {
        label: label,
        type: ui_extensions.InspectorInputType.SELECTBOX,
        datamember: datamember,
        list: list,
        visible: visibleDataMember,
        read_only: readOnly
    }
};

PackageGeneratorInspectorConfig.getTextbox = function(label, datamember, visibleDataMember, datatype, readOnly) {
    return {
        label: label,
        type: ui_extensions.InspectorInputType.TEXT,
        datatype: datatype,
        datamember: datamember,
        visible: visibleDataMember,
        read_only: readOnly
    }
};

PackageGeneratorInspectorConfig.getValueFixedUnit = function(label, tooltip, datamember, unitmember, visibleDataMember, readOnly) {
    return {
        label: label,
        tooltip: tooltip,
        type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
        datamember: datamember,
        datatype: cio_config.types.positive_float,
        unitmember: unitmember,
        visible: visibleDataMember,
        read_only: readOnly
    }
};

PackageGeneratorInspectorConfig.getMinMaxRow = function(label, tooltip, minDisabled, minDatamember, maxDisabled, maxDatamember, unitmember, readOnly, visibleDataMember) {
    return {
        label: '', //TODO: Is it needed?
        type: ui_extensions.InspectorInputType.ROW,
        visible: visibleDataMember,
        items: [
            {
                label: label,
                tooltip: tooltip,
                type: ui_extensions.InspectorInputType.LABEL
            }, {
                label: '', //TODO: Is it needed?
                tooltip: 'min',
                type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember: minDatamember,
                datatype: cio_config.types.positive_float,
                unitmember: unitmember,
                disabled: minDisabled,
                read_only: readOnly
            }, {
                label: '', //TODO: Is it needed?
                tooltip: 'max',
                type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember: maxDatamember,
                datatype: cio_config.types.positive_float,
                unitmember: unitmember,
                disabled: maxDisabled,
                read_only: readOnly
            }
        ]

    }
};

PackageGeneratorInspectorConfig.getLabel = function(label) {
    return {
        label: label,
        type: ui_extensions.InspectorInputType.LABEL
    }
};

PackageGeneratorInspectorConfig.getCheckBox = function(label, datamember, visibleDataMember, readOnly) {
    return {
        label: label,
        type: ui_extensions.InspectorInputType.CHECKBOX,
        datamember: datamember,
        visible: visibleDataMember,
        read_only: readOnly
    }
};

PackageGeneratorInspectorConfig.getImage = function(url, visibleDataMember, label, tooltip) {
    return {
        label: label,
        tooltip: tooltip,
        image: url,
        type: ui_extensions.InspectorInputType.IMAGE,
        visible: visibleDataMember
    }
};

module.exports = PackageGeneratorInspectorConfig;
